import { ecsApi } from '@services';
import { EpiFavoriteOrderCreatePayload, EpiFavoriteOrderCreateResponse, GetEpiFavoriteOrdersResponse } from './epiFavoriteOrders.types';

export const epiFavoriteOrdersApi = ecsApi.injectEndpoints({
    endpoints: (builder) => ({
        getEpiFavoriteOrders: builder.mutation<GetEpiFavoriteOrdersResponse, undefined>({
            query: () => ({
                url: '/orders-epi/favorites',
                method: 'GET'
            })
        }),
        createEpiFavoriteOrder: builder.mutation<EpiFavoriteOrderCreateResponse, EpiFavoriteOrderCreatePayload>({
            query: (payload) => ({
                url: '/orders-epi/favorites',
                method: 'POST',
                body: payload
            })
        })
    })
});

export const { useGetEpiFavoriteOrdersMutation, useCreateEpiFavoriteOrderMutation } = epiFavoriteOrdersApi;
